import { features } from '@/mocks/about';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择 <span className="text-primary-500">小蓝视频</span>？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            四大核心优势，打造极致短视频体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-lg bg-background-100/70 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}